import Swiper from 'swiper';
import { Pagination, A11y } from 'swiper/modules';

// Configure Swiper to use modules
Swiper.use([Pagination, A11y]);

const swiper = new Swiper('.swiper', {
  slidesPerView: 1,
  spaceBetween: 10,

  breakpoints: {
    1048: {
      slidesPerView: 1,
      spaceBetween: 70,
    },
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

